import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Enterprise} from '../../../model/Enterprise';
import {Partner} from '../../../model/Partner';
import {Constant} from '../../../../global/util/Constant';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PersonService} from '../../../service/person.service';
import {JobService} from '../../../service/job.service';
import {AuthService} from '../../../service/auth/auth.service';
import {EnterpriseService} from '../../../service/enterprise.service';
import {Dialog} from '../../../../global/util/Dialog';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {StringUtil} from '../../../../global/util/StringUtil';
import {Something} from '../../../model/Something';
import {InformType} from '../../../../global/util/enum/InformType';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {TranslateService} from '@ngx-translate/core';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-add-people-batch',
  templateUrl: './add-people-batch.component.html',
  styleUrls: ['./add-people-batch.component.css']
})
export class AddPeopleBatchComponent implements OnInit {
  public title = 'TITLE.PERSON';
  public personForm: FormGroup;
  public loading: boolean;
  public enterprises: Enterprise[] = [];
  public partners: Partner[] = [];
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public something = new Something();
  public progressUpload = 0;
  public alertMessage: string;

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private personService: PersonService,
              private jobService: JobService,
              private authenticationService: AuthService,
              private enterpriseService: EnterpriseService,
              private enterpriseDataService: EnterpriseDataService,
              private modalService: NgbModal,
              private translate: TranslateService) {
    Dialog.createInstance(modalService);
    this.createForm();
    this.alertMessage = this.translate.instant('MESSAGE.FILE-MUST-HAVE-A-DEFINED-STRUCTURE') +
      '<a target="_blank" href="https://drive.google.com/drive/folders/1icjVNHltuy4chUHsJo8qrOYU6GY47DWj?usp=sharing">' + this.translate.instant('LINK.HERE') + '</a>';
  }

  ngOnInit() {
    this.configGlobalData();
  }

  private configGlobalData() {
    this.loadGlobalDefaultData();
  }

  // public save() {
  //   // if (this.personForm.invalid) {
  //   //   this.markAsTouchedControls4BatchLoad();
  //   //   return;
  //   // }
  //   this.upload();
  // }

  openConfirmDialog(): void {
    if (this.personForm.invalid) {
      this.markAsTouchedControls4BatchLoad();
      return;
    }
    const modalRef = this.modalService.open(ConfirmComponent, {
      backdrop: 'static'
    });
    modalRef.componentInstance.title = this.translate.instant('TITLE.MASSIVE-LOADING-PEOPLE');
    modalRef.componentInstance.body = this.translate.instant('MESSAGE.IF-EXISTING-DATA-ALREADY-REGISTERED');
    modalRef.result.then(value => {
      if (Response.Yes === value) {
        this.upload();
      }
    });
  }

  /**
   * Marca como touched los controles necesarios en el registro masivo de personas
   * @private
   */
  private markAsTouchedControls4BatchLoad() {
    const control = this.personForm.get('sourceDataExcelFile');
    control.markAsTouched();
  }

  private upload(): void {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/enterprises/', String(this.something.enterpriseId), '/people');
    const formData = new FormData();
    const xlsFile = this.personForm.get('sourceDataExcelFile').value;
    formData.append('xlsFile', xlsFile);
    this.personService.upload(url, formData).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          // TODO When request has been made
          break;
        case HttpEventType.ResponseHeader:
          // TODO When response header has been received
          break;
        case HttpEventType.UploadProgress:
          this.progressUpload = Math.round(event.loaded / event.total * 100);
          break;
        case HttpEventType.Response:
          this.loading = false;
          this.activeModal.close({informType: InformType.Success, people: event.body._embedded.people});
          break;
      }
    }, response => {
      this.loading = false;
      this.activeModal.close({informType: InformType.Danger, message: response.error.message});
    });
  }

  public cancel() {
    this.activeModal.close(Constant.CANCEL);
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  public createForm() {
    this.personForm = this.formBuilder.group(
      {
        partner: [''],
        enterprise: [''],
        sourceDataExcelFile: ['', [Validators.required]],
        sourceDataExcelFilename2Show: [''],
      });
  }

  public isInvalidControl(ctrlName: string) {
    return this.personForm.get(ctrlName).invalid && this.personForm.get(ctrlName).touched;
  }

  public getErrorMessageBy(controlName: string): string {
    const control = this.personForm.get(controlName);
    const hasRequiredError = control.hasError('required');
    const hasPatternError = control.hasError('pattern');
    let actualValue;
    switch (controlName) {
      case 'lastname':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.LAST-NAME-ARE-REQUIRED');
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return this.translate.instant('MESSAGE.DO-NOT-ENTER-SPACES-AT-BEGINNING-AND-END-OF-THE-LAST-NAMES');
        }
        break;
      case 'lastname2':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.LAST-NAME-ARE-REQUIRED');
        } else if (hasPatternError) {
          actualValue = control.errors.pattern.actualValue;
          return this.translate.instant('MESSAGE.DO-NOT-ENTER-SPACES-AT-BEGINNING-AND-END-OF-THE-LAST-NAMES');
        }
        break;
    }
  }

  private loadGlobalDefaultData() {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartners();
      this.something.partnerId = this.partners[0].id;
      this.enterprises = this.getEnterprises(this.something.partnerId);
      this.something.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      this.something.partnerId = LocalStorage.getPartnerId();
      this.enterprises = this.getEnterprises(this.something.partnerId);
      this.something.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
    } else {
      this.something.partnerId = LocalStorage.getPartnerId();
      this.something.enterpriseId = LocalStorage.getEnterpriseIdView();
    }
  }

  public reloadEnterprises() {
    this.enterprises = this.getEnterprises(this.something.partnerId);
    this.something.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
    // TODO AL SELECCIONAR ROL PARTNER -> PARTNER Y SELECCIONAR LA EMPE4SA
  }

  private getEnterprises(partnerId: number): Enterprise[] {
    return this.enterpriseDataService.getEnterprises().filter(value => partnerId === value.partnerId && Constant.NOT_EXCLUDED === value.excluded);
  }

  public changeStatus(event) {
    const excelLayoutFile = (event.target as HTMLInputElement).files[0];
    if (!excelLayoutFile.name.endsWith('.xls') && !excelLayoutFile.name.endsWith('.xlsx')) {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.PERSON'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
      return;
    }
    this.personForm.patchValue({
      sourceDataExcelFile: excelLayoutFile,
      sourceDataExcelFilename2Show: StringUtil.cut(excelLayoutFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.personForm.get('sourceDataExcelFile').updateValueAndValidity();
  }
}
